import styled from 'styled-components'
import { t } from 'ttag'
import { useContext, useState } from 'react'

import { Flex } from '@h2/components/layout/flex'
import { Box } from '@h2/components/layout/box'
import { Text } from '@h2/components/typography/text'
import { InfoCircleIcon } from '@h2/components/icons/infoCircle'
import { EducatorsCodeIcon } from '@h2/components/icons/educatorsCode'
import { SDB, PB97T } from '@h2/components/colors'
import { features } from '@h2/components/media'
import ExplanationModal from '@main/containers/educators/EducatorCodeExplanationModal'

import { Context } from '../context'

const FlexWrap = styled(Flex)`
  display: none;

  @media (${features.minWidth.laptop}) {
    display: flex;
    padding: 6px 10px;
    cursor: pointer;
    height: 100%;
    background-color: white;

    &:hover {
      background-color: ${PB97T};
    }

    > div:nth-child(2) {
      > span {
        display: block;
        margin: 0;
      }
    }
  }
`
const EducatorCode = () => {
  const { userProfile } = useContext(Context)
  const [isModalOpen, setIsModalOpen] = useState(false)

  if (!userProfile || !userProfile.management) {
    return null
  }

  return (
    <>
      <FlexWrap onClick={() => setIsModalOpen(true)} role="button" tabIndex="0">
        <Box>
          <EducatorsCodeIcon size="medium" />
        </Box>
        <Box px="10px">
          <Text as="span" size="small">{t`Navigator Code`}</Text>
          <Text as="span" color={SDB} weight="bold" size="large" transform="uppercase">
            {userProfile.management.code}
          </Text>
        </Box>
        <Box>
          <InfoCircleIcon size="tiny" />
        </Box>
      </FlexWrap>
      {isModalOpen && (
        <ExplanationModal
          show={isModalOpen}
          management={userProfile.management}
          toggleVisibility={() => setIsModalOpen(!isModalOpen)}
        />
      )}
    </>
  )
}

export { EducatorCode }
